import { User } from "types";
import { getAge, getStorageImage } from "helpers";

const transformUser = (data: any): User => {
  const {
    id,
    image,
    firstName,
    middleName,
    lastName,
    email,
    phoneNumber,
    gender,
    birthDate,
    height,
    weight,
    bmi,
    bloodType,
    otherDisease,
    allergies,
    currentMedication,
    pastMedication,
    injuries,
    surgeries,
    activityLevel,
    fitness,
    foodPreference,
    nutrition,
    calorie,
    smokingHabits,
    alcoholConsumption,
  } = data;

  return {
    id,
    image: image && getStorageImage(image, "users"),
    firstName,
    middleName,
    lastName,
    displayName: `${firstName} ${lastName}`,
    email,
    phone: phoneNumber,
    gender: gender.toString() ? gender.toString() === "0" ? "female" : "male" : "",
    birthday: birthDate ? birthDate : "",
    age: birthDate ? getAge(birthDate) : "",
    height: Number(height),
    weight: Number(weight),
    bmi,
    bloodType,
    diseases: otherDisease && otherDisease.replace("None", ""),
    allergies,
    currentMedications: currentMedication,
    pastMedications: pastMedication,
    injuries,
    surgeries,
    activityLevel,
    fitnessLevel: fitness,
    foodPreference,
    nutritionPlan: nutrition,
    calories: calorie,
    smoking: smokingHabits,
    alcohol: alcoholConsumption,
  };
};

export { transformUser };
